import { render, staticRenderFns } from "./idPc.vue?vue&type=template&id=5d38bd9a&scoped=true&"
import script from "./idPc.vue?vue&type=script&lang=js&"
export * from "./idPc.vue?vue&type=script&lang=js&"
import style0 from "./idPc.vue?vue&type=style&index=0&id=5d38bd9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d38bd9a",
  null
  
)

export default component.exports